<template>
	<div id="app" :style="platforms=='app'?{height: bodyHeight + 'px'}:''">
		<!-- :style="{ height: bodyHeight + 'px' }" -->
		<router-view />

		<!-- 声音提醒 -->
		<audio controls="controls" hidden src="./static/mp3/msg.wav" ref="altaudio"></audio>

		<share ref="ref-wx-share" :showShareSheet.sync="showShareSheet" :shareUrl="Conf.clientOrigin" :shareConfig="shareConfig" :botm="0" v-show="showShareSheet" v-if="initShareSheet"/>
	</div>
</template>
<script>
	import Share from "@/components/Commom/Share";
	export default {
		name: "App",
		components: {
			"share":Share
		},
		data() {
			return {
				u_id: localStorage.getItem("u_id"),
				token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
				ws_url: localStorage.getItem("ws_url"),
				bodyHeight:"",
				platforms: null,
				chkSocketTimer:false,
				rndid : null,

				showShareSheet:false,
				shareConfig:{
					title:top._SHARE_INFO.title,
					desc:top._SHARE_INFO.desc,
					link: this.Conf.clientOrigin, // 分享链接
					imgUrl: this.Conf.clientOrigin+'/statics/logo_h5.png'// 分享图标
				},
				initShareSheet:true
			};
		},
		mounted(){
			this.bodyHeight=document.documentElement.clientHeight;
			this.rndid = this.$store.state.common.rndid;
		},
		created() {
			//if(!localStorage.getItem("lnglat")){
				this.getLocation();
			//}
			this.platforms = this.Conf.platform;
			if (this.u_id && this.token && this.ws_url) {
				if (!(this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1) ) {
					this.localSocket();
				}
			} else {
				this.chkLogined();
				this.chkSocketTimer = setTimeout(() => {
					this.chkSocketState();
				}, 2000);
			}

			let that = this;
			this.$nextTick(() => {
				that.setSkinGray();
				if (!window.plus) {
					that.initShareSheet = true;
				}
			});
		},

		methods:{ 
			setSkinGray(){
				let gray = this.$store.state.common.gray;
				if(gray){
					if(gray == "all"){
						document.getElementById("app").className = document.getElementById("app").className + " gray_skin";
					}else{
						let elms = document.getElementsByClassName(gray);
						if(elms.length > 0){
							elms[0].className = elms[0].className + " gray_skin";
						}
					}
				}
			},
			getLocation() {
				const self = this
				AMap.plugin('AMap.Geolocation', function () {
					var geolocation = new AMap.Geolocation({
						// 是否使用高精度定位，默认：true
						enableHighAccuracy: true,
						// 设置定位超时时间，默认：无穷大
						timeout: 10000,
					})

					geolocation.getCurrentPosition()
					AMap.event.addListener(geolocation, 'complete', onComplete);
					AMap.event.addListener(geolocation, 'error', onError);

					function onComplete(data) {
						// data是具体的定位信息
						console.log('定位成功信息：', data);
						localStorage.setItem("lnglat", data.position.lng+","+data.position.lat);
					}

					function onError(data) {
						// 定位出错
						console.log('定位失败错误：', data);
						// 调用ip定位
						self.getLngLatLocation();
					}
				})
			},
			getLngLatLocation() {
				AMap.plugin('AMap.CitySearch', function () {
					var citySearch = new AMap.CitySearch();

					citySearch.getLocalCity(function (status, result) {
						if (status === 'complete' && result.info === 'OK') {
							//逆向地理编码
							AMap.plugin('AMap.Geocoder', function () {
								var geocoder = new AMap.Geocoder({
									// city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
									city: result.adcode
								})
								localStorage.setItem("lnglat", result.rectangle.split(';')[0]);
								/**
								var lnglat = result.rectangle.split(';')[0].split(',');
								geocoder.getAddress(lnglat, function (status, data) {
									if (status === 'complete' && data.info === 'OK') {
										// result为对应的地理位置详细信息
										console.log(data)
									}
								})
								*/
							})
						}
					})
				})
			},
			chkLogined(){
				let rpaths = this.$route.path.toLowerCase().split("/");
				//console.log(rpaths)
				//rpaths = rpaths[rpaths.length-1].split("?");
				//console.log(rpaths)
				const wrouters = ["remindinfo","news", "shop", "regist", "login","shopping","cart","product","authcall",'clans'];
				if (!(rpaths.length==0 || (rpaths.length>0 && (rpaths[1]=='' || wrouters.includes(rpaths[1]) || (rpaths[1]=='clans'&&rpaths.length==2)))) && !(localStorage.getItem("u_id") && localStorage.getItem(localStorage.getItem("u_id") + "token"))) {
					localStorage.setItem("before_path", this.$route.path);
					this.$router.push({
						path: "/login"
					});
					return false;
				}
				return true;
			},
			chkSocketState() {
				if (this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
					this.chkSocketTimer && clearTimeout(this.chkSocketTimer);
				} else {
					this.reconnect();
				}
				return false;
			}, 
			localSocket(){
				if ("WebSocket" in window) {
					var ws_url = localStorage.getItem("ws_url");
					console.log("您的浏览器支持 WebSocket!");
					if (ws_url) {
						console.log("开始连接websocket");
						// 实例化websocket连接
						//this.Socket = new WebSocket(
						//	ws_url + "?uid=" + u_id + "&token=" + token
						//);
						this.Socket = new WebSocket(ws_url+"?rndid="+this.rndid);
						// 注册进全局
						this.websocket.setWs(this.Socket);
						// 监听socket连接
						this.websocket.ws.onopen = this.open;
						// 监听socket错误信息
						this.websocket.ws.onerror = this.error;
						// 监听消息回调
						this.websocket.ws.onmessage = this.getMessage;
						// 监听连接关闭
						this.websocket.ws.onclose = this.close;
					}else{
						console.log("参数异常，无法连接websocket，2s后重新连接");
						this.reconnect();
					}
				} else {
					console.log("您的浏览器不支持 WebSocket!");
				}
			},
			//重新连接
			reconnect() {
				var that = this;
				if (that.websocket.lockReconnect) {
					return;
				}
				that.websocket.lockReconnect = true;
				//没连接上会一直重连，设置延迟避免请求过多
				that.timeoutnum && clearTimeout(that.timeoutnum);
				that.timeoutnum = setTimeout(function() {
					that.websocket.connected = false;
					that.websocket.lockReconnect = false;
					console.log("WebSocket重新连接中...");
					//新连接
					that.localSocket();
				}, 2000);
			},
			//开启心跳
			start() {
				var that = this;
				clearInterval(window.wsHeartTimer);
				that.websocket.ws.send("heartCheck");
				window.wsHeartTimer = setInterval(function() {
					if (that.websocket.ws.readyState == 1) {
						console.log("发送WebSocket心跳...");
						that.websocket.ws.send("heartCheck");
					} else {
						console.log("WebSocket连接已经关闭");
						that.reconnect();
					}
				}, 20000);
			},
			// 监听socket连接
			open() {
				this.websocket.connected = true;
				console.log("WebSocket连接成功");
				var u_id = localStorage.getItem("u_id");
				var u_token = localStorage.getItem(u_id + "token");
				if(u_id && u_token){// 绑定已登录用户
					this.websocket.ws.send(JSON.stringify({
						mk:200,
						uid:u_id,
						token:u_token,
						rndid:this.rndid
					}));
				}
				//开启心跳
				this.start();
			},
			// 监听socket连接错误
			error() {
				this.websocket.connected = false;
				console.log("发生错误WebSocket重连");
				//重连
				this.reconnect();
			},
			// 监听socket连接关闭
			close(e) {
				this.websocket.connected = false;
				console.log("WebSocket关闭重连" + e.code + " " + e.reason + " " + e.wasClean);
				this.reconnect();
			},
			getMessage: function(msg) {
				//console.log('app',msg)
				var that = this;
				var data = JSON.parse(msg.data);
				if (data && data.m_type == "alert") {
					that.$toast(data.m_post_messages);
					return;
				}
				switch (data.status) {
					case 1:
						// token为空时
						that.$dialog
						.alert({
							message: data.message
						})
						.then(() => {
							that.$router.push({ path: "/login" });
						});
						break;
					case 2:
						// 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
						if (localStorage.getItem(localStorage.getItem("u_id") + "token") == data.token) {
							return;
						}
						// 用户在别处登录，客服端与服务端token不相等时
						// 客户端token 与 后台token不相等时，退出登入
						window.localStorage.clear();

						that.$dialog
						.alert({
							message: data.message
						})
						.then(() => {
							window.localStorage.clear();
							that.$router.push({ path: "/login" });
						});
						break;
					case 3:
						that.websocket.recordUnreadChat(data);
						//播放声音
						if(data.tag == "one"){
							var noDisturbing = localStorage.getItem( data.data.m_from_user_id + "noDisturbing" );

							if (that.u_id != data.data.m_from_user_id && noDisturbing != 1) {
								// console.log("当前chat播放音乐用户id：" + that.u_id);
								that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
								that.$refs.altaudio.play(); //播放
							}
						}else if (data.tag == "group") {
							var groupNoDistrrbing = localStorage.getItem( data.ug_id + "groupNoDistrrbing" );
							if ( that.u_id != data.data[0].gm_from_id && groupNoDistrrbing != 1
							) {
								// console.log("当前chat播放音乐用户id：" + that.u_id);
								that.$refs.altaudio.currentTime = 0; //从头开始播放提示音
								that.$refs.altaudio.play(); //播放
							}
						}
						that.websocket.staticsMsgUnread();
						break;
					case 6:
						that.websocket.recordUnreadShareLike();
						that.websocket.staticsShareUnread();
						break;
					case 7:
						that.websocket.recordUnreadShareComment(data);
						that.websocket.staticsShareUnread();
						break;
					case 99:
						that.$toast('你有一条新的'+data.message);
						break;
					case 200://授权登录
						data = data.message;
						that.$toast.success(data.msg);
						// 保存服务端返回的token、用户id
						localStorage.setItem(
							data.u_id + "token",
							data.token
						);
						localStorage.setItem("u_id", data.u_id);
						if (data.userInfo) {
							localStorage.setItem( "userInfo", JSON.stringify(data.userInfo) );
						}
						// 绑定通讯用户信息
						if ((that.websocket && that.websocket.ws && that.websocket.ws.readyState == 1) ) {
							that.websocket.ws.send(JSON.stringify({
								mk:200,
								uid:data.u_id,
								token:data.token,
								rndid:that.$store.state.common.rndid
							}));
						}
						localStorage.removeItem("inviter_code");
						// 登录成功跳转到首页
						if(that.prePath){
							localStorage.removeItem("before_path");
							that.$router.push({ path: prePath });
						}else{
							that.$router.push({ path: this.Conf.homeUrl });
						}
						break;
					case 300://授权绑定
						data = data.message;
						that.$toast.success(data.msg);
						that.$router.go(0);
						break;
					default:
						break;
				}
			}
		},
		watch: {
			$route(to, from) {
				this.chkLogined();
				if (this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
					this.websocket.ws.onmessage = this.getMessage;
				}
				this.setSkinGray();
				
				this.$refs['ref-wx-share'].resetInit();
			}
		},
	};
</script>




// WEBPACK FOOTER //
// src/App.vue